import { z } from 'zod';
import { SupportTicketStatusSchema } from '../list-support-tickets/list-support-tickets.schema';
/**
 * Who wrote a message in the conversation.
 *
 * Coarser than Zammad's sender model on purpose: the customer learns that
 * support answered, not which agent did. Naming an individual invites replies
 * addressed to a person who may be on leave, and leaks staffing structure.
 */ export const SupportTicketAuthorSchema = z.enum([
    'customer',
    'support'
]);
/**
 * A file on a message, in either direction: a screenshot the customer sent, or
 * something support attached in reply.
 *
 * No URL — the bytes live in Zammad and only our backend holds a token for
 * them, so downloads go through the endpoint that re-checks ownership.
 */ export const SupportTicketAttachmentSchema = z.object({
    id: z.number(),
    filename: z.string(),
    sizeBytes: z.number(),
    mimeType: z.string()
});
/**
 * One message in a ticket conversation.
 *
 * `body` is plain text. Zammad stores article bodies as HTML authored by
 * agents and by inbound mail, which is untrusted input — it is flattened
 * server-side so no consumer is ever tempted to render it as markup.
 */ export const SupportTicketMessageSchema = z.object({
    id: z.number(),
    body: z.string(),
    author: SupportTicketAuthorSchema,
    createdAt: z.string(),
    attachments: z.array(SupportTicketAttachmentSchema)
});
/**
 * Show Support Ticket Response Schema
 * GET /api/v2/support/tickets/:ticketId
 */ export const ShowSupportTicketResponseSchema = z.object({
    ticket: z.object({
        id: z.number(),
        number: z.string(),
        title: z.string(),
        status: SupportTicketStatusSchema,
        createdAt: z.string(),
        updatedAt: z.string()
    }),
    messages: z.array(SupportTicketMessageSchema),
    /**
   * For a merged ticket, the request it went into — only when that one is the
   * same customer's; otherwise null, so a merge never names a stranger's ticket.
   */ mergedInto: z.object({
        id: z.number(),
        number: z.string()
    }).nullable()
});
/**
 * Route template of the attachment download endpoint. Owned here rather than
 * in the contract because the response is raw bytes, not a schema — and so the
 * path the UI links to and the path the endpoint answers on cannot drift.
 */ export const SUPPORT_ATTACHMENT_DOWNLOAD_PATH_TEMPLATE = '/api/v2/support/tickets/:ticketId/messages/:messageId/attachments/:attachmentId';
export function supportAttachmentDownloadPath(params) {
    return SUPPORT_ATTACHMENT_DOWNLOAD_PATH_TEMPLATE.replace(':ticketId', String(params.ticketId)).replace(':messageId', String(params.messageId)).replace(':attachmentId', String(params.attachmentId));
}

//# sourceMappingURL=show-support-ticket.schema.js.map